module.exports = __webpack_public_path__ + "static/ext1-6a4bbe1f3dfefa42b299dc2a9041162c.png";